import { EntityService } from './EntityService';
import { IPartnerOrganisationRiskRiskType } from '../types/PartnerOrganisationRiskRiskType';

export class PartnerOrganisationRiskRiskTypeService extends EntityService<IPartnerOrganisationRiskRiskType> {
    constructor() {
        super(`/PartnerOrganisationRiskRiskTypes`);
    }
}